import axios from '../../http/axios/index.js'

const API_URL = 'https://selfie.cash'

export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  fetchPayments({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/payments`)
        .then((response) => {
          commit('SET_PAYMENTS', response.data.allPayment)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUser(context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`${API_URL}/api/management/users/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`${API_URL}/api/management/users/${id}`)
        .then((response) => {
          commit('REMOVE_RECORD', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", payload.file); // appending file
      formData.append("id", payload.userDetails.id);
      formData.append("name", payload.userDetails.name);
      formData.append("dob", payload.userDetails.dob);
      formData.append("organization", payload.userDetails.organization);
      formData.append("department", payload.userDetails.department);
      formData.append("team", payload.userDetails.team);
      formData.append("gender", payload.userDetails.gender);
      formData.append("role", payload.userDetails.role);
      axios
        .post("/api/management/updateUser", formData)
        .then((res) => {
          commit('UPDATE_USER', { user: payload.userDetails, path: res.data.file ? res.data.path : '' })
          this._vm.$vs.notify({
            color: "success",
            title: "User Update Success!",
            text: res.data.message,
          });
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  approveRecord({ commit }, id) {

    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/api/management/paymentsApprove/${id}`)
        .then((response) => {
          this._vm.$vs.notify({
            color: "success",
            title: "Payment Approved",
            text: response.data.message,
          });
          // commit('APPROVE_USER_PAYMENT', id)
          commit('APPROVE_PAYMENT', id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  rejectRecord({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/api/management/paymentsReject/${data.userId}`, data)
        .then((response) => {
          this._vm.$vs.notify({
            color: "danger",
            title: "Payment Rejected",
            text: response.data.message,
          });
          // commit('REJECT_USER_PAYMENT', id);
          commit('REJECT_PAYMENT', data);

          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
